<template>
  <div>
    <h3>В данном разделе Вы можете загрузить бухгалтерские документы по Вашим проектам</h3>
    <br>
    <no-data v-if="documents.length === 0"></no-data>
    <c-document-item
      v-else
      v-for="(item) in documents"
      :key="item.key"
      :data="item"
    />
  </div>
</template>

<script>
import CDocumentItem from '../components/ui/CDocumentItem.vue'
import NoData from '../../../../../../resources/js/components/NoData.vue'
import apiService from '../apiService'
import { Notification } from 'uiv'

export default {
  name: 'Documents',
  components: {
    NoData,
    CDocumentItem
  },
  data () {
    return {
      documents: [],
      fetchingDocuments: false
    }
  },
  mounted () {
    this.fetchDocuments().then(this.onDocumentsResolve)
  },
  methods: {
    /**
     * Метод-обёртка над запросом к API /api/context/documents
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchDocuments () {
      this.fetchingDocuments = true
      return new Promise(resolve => {
        apiService.getDocumentsData()
          .then(response => {
            this.fetchingDocuments = false
            resolve(response.data)
          })
          .catch(() => {
            this.fetchingDocuments = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось загрузить бухгалтерские документы.'
            })
          })
      })
    },
    /**
     * Выводит данные в компонент
     * @param data Данные из Promise
     */
    onDocumentsResolve (data) {
      this.documents = data.documents
    }
  }
}
</script>

<style scoped lang="scss">

</style>
